class RelatedServices extends DrupalBehavior {
  onContent(context) {
    once('RelatedServices', '.expandable-list', context).forEach((item) => {
      const listItems = item.querySelectorAll('.expandable-list--items ul li');

      if (listItems.length > 10) {
        const showButton = document.createElement(`a`);
        showButton.classList.add(`view-more`);
        showButton.innerText = `View More`;

        showButton.addEventListener(`click`, function () {
          if (item.classList.contains(`active`)) {
            showButton.textContent = `View More`;
            item.classList.remove('active');
          }
          else {
            showButton.textContent = `View Less`;
            item.classList.add('active');
          }
        });
        item.appendChild(showButton);
      }
    });
  }
}

DrupalBehavior.register('summit_theme', 'related_services', RelatedServices);